export default "__VITE_ASSET__DgQ550yp__"